/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DesadvUploadResponseV3 } from '../models/desadv-upload-response-v-3';
import { postConsignorDesadv } from '../fn/edi/post-consignor-desadv';
import { PostConsignorDesadv$Params } from '../fn/edi/post-consignor-desadv';

@Injectable({ providedIn: 'root' })
export class EdiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postConsignorDesadv()` */
  static readonly PostConsignorDesadvPath = '/organization-sites/{organizationSiteKey}/consignor/desadv';

  /**
   * Upload a DESADV file to enrich delivery notes with article data.
   *
   * Accepts an EANCOM DESADV (EDIFACT D.01B) document that may contain
   * several DESADV messages. For every message the order number is
   * resolved to the consignor's own delivery note. A note is enriched
   * with the message's structured article data only when it is uniquely
   * resolved, still open, and does not already carry protected
   * (manually uploaded or previously DESADV-imported) articles.
   * Notes with only AI-read articles are overwritten. All other cases
   * are skipped and reported. The raw file is never persisted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postConsignorDesadv()` instead.
   *
   * This method sends `application/edifact` and handles request body of type `application/edifact`.
   */
  postConsignorDesadv$Response(params: PostConsignorDesadv$Params, context?: HttpContext): Observable<StrictHttpResponse<DesadvUploadResponseV3>> {
    const obs = postConsignorDesadv(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Upload a DESADV file to enrich delivery notes with article data.
   *
   * Accepts an EANCOM DESADV (EDIFACT D.01B) document that may contain
   * several DESADV messages. For every message the order number is
   * resolved to the consignor's own delivery note. A note is enriched
   * with the message's structured article data only when it is uniquely
   * resolved, still open, and does not already carry protected
   * (manually uploaded or previously DESADV-imported) articles.
   * Notes with only AI-read articles are overwritten. All other cases
   * are skipped and reported. The raw file is never persisted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postConsignorDesadv$Response()` instead.
   *
   * This method sends `application/edifact` and handles request body of type `application/edifact`.
   */
  postConsignorDesadv(params: PostConsignorDesadv$Params, context?: HttpContext): Observable<DesadvUploadResponseV3> {
    const resp = this.postConsignorDesadv$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DesadvUploadResponseV3>): DesadvUploadResponseV3 => r.body)
    );
  }

}
